// import React from 'react';
// // fields: [{ label, key, readOnly }], data: object, onClose: fn, onSave: fn, title: string
// function EditModal({ title, fields, data, onClose, onSave }) {
//     return (
//         <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
//             <div style={{ background: '#fff', borderRadius: 8, padding: 32, minWidth: 320, boxShadow: '0 2px 12px rgba(0,0,0,0.12)' }}>
//                 <h3 style={{ marginBottom: 16 }}>{title}</h3>
//                 <form>
//                     {fields.map((field) => (
//                         <div key={field.key} style={{ marginBottom: 12 }}>
//                             <label>{field.label}:</label>
//                             <input
//                                 type="text"
//                                 value={
//                                     Array.isArray(data[field.key])
//                                         ? data[field.key].join(', ')
//                                         : data[field.key] ?? ''
//                                 }
//                                 readOnly={field.readOnly}
//                                 style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
//                             />
//                         </div>
//                     ))}
//                 </form>
//                 <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 16 }}>
//                     <button onClick={onClose} style={{ padding: '8px 24px', borderRadius: 4, border: '1px solid #ccc', background: '#eee', cursor: 'pointer' }}>Cancel</button>
//                     <button onClick={onSave} style={{ padding: '8px 24px', borderRadius: 4, border: 'none', background: '#E30613', color: '#fff', cursor: 'pointer' }}>Save</button>
//                 </div>
//             </div>
//         </div>
//     );
// }
// export default EditModal

import React, { useState, useEffect } from 'react';
import { Trash2, X } from 'lucide-react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ImageResize from 'quill-image-resize-module-react';

Quill.register('modules/imageResize', ImageResize);
// fields: [{ label, key, readOnly, type }], data: object, onClose: fn, onSave: fn, title: string
// function EditModal({ title, fields, data, onClose, onSave }) {
//     const [formData, setFormData] = useState({});
//     const [isSaving, setIsSaving] = useState(false);

//     useEffect(() => {
//         const initialData = {};
//         if (fields && Array.isArray(fields)) {
//             fields.forEach(field => {
//                 initialData[field.key] = Array.isArray(data?.[field.key])
//                     ? data[field.key].join(', ')
//                     : data?.[field.key] ?? '';
//             });
//         }
//         setFormData(initialData);
//     }, [fields, data]);

//     const handleChange = (key, value) => {
//         setFormData(prev => ({ ...prev, [key]: value }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setIsSaving(true);
//         await onSave(formData);
//         setIsSaving(false);
//     };

//     const handleBackdropClick = (e) => {
//         if (e.target === e.currentTarget) {
//             onClose();
//         }
//     };

//     return (
//         <div 
//             onClick={handleBackdropClick}
//             className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999] p-4 animate-fade-in"
//         >
//             <style>{`
//                 @keyframes fade-in {
//                     from { opacity: 0; }
//                     to { opacity: 1; }
//                 }
//                 @keyframes slide-up {
//                     from { 
//                         opacity: 0;
//                         transform: translateY(20px);
//                     }
//                     to { 
//                         opacity: 1;
//                         transform: translateY(0);
//                     }
//                 }
//                 .animate-fade-in {
//                     animation: fade-in 0.2s ease-out;
//                 }
//                 .animate-slide-up {
//                     animation: slide-up 0.3s ease-out;
//                 }
//             `}</style>
//             <div 
//                 className="bg-white rounded-xl w-full max-w-lg max-h-[90vh] overflow-hidden shadow-2xl flex flex-col animate-slide-up"
//             >
//                 {/* Header */}
//                 <div className="px-8 py-6 border-b border-gray-200 flex justify-between items-center">
//                     <h3 className="text-xl font-semibold text-gray-900 m-0">{title}</h3>
//                     <button
//                         onClick={onClose}
//                         className="w-8 h-8 rounded-md flex items-center justify-center p-0 border-0 bg-transparent hover:bg-gray-100 transition-all duration-200 hover:rotate-90"
//                     >
//                         <X size={20} className="text-gray-600" />
//                     </button>
//                 </div>

//                 {/* Form Content */}
//                 <div className="flex-1 overflow-auto px-8 py-6">
//                     {fields && fields.length > 0 ? (
//                         fields.map((field) => (
//                             <div key={field.key} className="mb-5">
//                                 <label className="block mb-2 text-sm font-medium text-gray-700">
//                                     {field.label}
//                                     {field.readOnly && (
//                                         <span className="ml-2 text-xs text-gray-500 font-normal">
//                                             (read-only)
//                                         </span>
//                                     )}
//                                 </label>
//                                 <input
//                                     type={field.type || "text"}
//                                     value={formData[field.key] || ''}
//                                     onChange={(e) => handleChange(field.key, e.target.value)}
//                                     disabled={field.readOnly}
//                                     className="w-full px-3.5 py-2.5 rounded-lg border-2 border-gray-300 text-sm focus:outline-none focus:border-red-600 focus:ring-4 focus:ring-red-600/10 disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200"
//                                 />
//                             </div>
//                         ))
//                     ) : (
//                         <div className="text-center py-5 text-gray-500">
//                             No fields to display
//                         </div>
//                     )}
//                 </div>

//                 {/* Footer */}
//                 <div className="px-8 py-5 border-t border-gray-200 bg-gray-50 flex justify-end gap-3">
//                     <button 
//                         type="button"
//                         onClick={onClose} 
//                         disabled={isSaving}
//                         className="px-6 py-2.5 rounded-lg border-2 border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 hover:-translate-y-0.5 hover:shadow-lg disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none transition-all duration-200 active:translate-y-0"
//                     >
//                         Cancel
//                     </button>
//                     <button 
//                         type="button"
//                         onClick={handleSubmit}
//                         disabled={isSaving}
//                         className="px-7 py-2.5 rounded-lg border-0 bg-gradient-to-br from-red-600 to-red-700 text-sm font-medium text-white hover:from-red-700 hover:to-red-800 hover:-translate-y-0.5 hover:shadow-lg disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none transition-all duration-200 active:translate-y-0"
//                     >
//                         {isSaving ? 'Saving...' : 'Save Changes'}
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// }

function EditModal({ title, fields, data, onClose, onSave, errorMessage = '', onImproveQuillField, saveProgress = null, saveStatusText = '' }) {
    const [formData, setFormData] = useState({});
    const [isSaving, setIsSaving] = useState(false);
    const [improvingFieldKey, setImprovingFieldKey] = useState('');
    const getQuillModules = (toolbarId) => ({
        toolbar: `#${toolbarId}`,
        imageResize: {
            modules: ['Resize', 'DisplaySize'],
        },
    });

    const quillFormats = [
        'header',
        'bold',
        'italic',
        'underline',
        'strike',
        'color',
        'background',
        'list',
        'bullet',
        'align',
        'link',
        'image',
    ];


    // Helper to extract variables from content
    const extractVariables = (text) => {
        const regex = /{{(.*?)}}/g;
        const matches = [];
        let match;
        while ((match = regex.exec(text)) !== null) {
            matches.push(match[1].trim());
        }
        return [...new Set(matches)];
    };

    // Track variables in state
    const [detectedVariables, setDetectedVariables] = useState([]);

    useEffect(() => {
        const initialData = {};
        if (fields && Array.isArray(fields)) {
            fields.forEach(field => {
                if (field.type === 'file') {
                    initialData[field.key] = [];
                } else if (field.type === 'multiselect') {
                    const rawValue = data?.[field.key];

                    if (Array.isArray(rawValue)) {
                        initialData[field.key] = rawValue;
                    } else if (typeof rawValue === 'string') {
                        initialData[field.key] = rawValue
                            .split(',')
                            .map((value) => value.trim())
                            .filter(Boolean);
                    } else {
                        initialData[field.key] = [];
                    }
                } else {
                    initialData[field.key] = Array.isArray(data?.[field.key])
                        ? data[field.key].join(', ')
                        : data?.[field.key] ?? '';
                }
            });
        }

        initialData.removedProductDocuments = [];
        initialData.removedOnboardingFiles = [];

        // Extract variables from content if present
        let content = initialData.content || data?.content || '';
        const vars = extractVariables(content);
        setDetectedVariables(vars);
        // Initialize variable values
        if (vars.length > 0) {
            vars.forEach((v) => {
                if (initialData[v] === undefined) {
                    initialData[v] = (data?.variableValues && data.variableValues[v]) || '';
                }
            });
        }
        setFormData(initialData);
    }, [fields, data]);

    // Watch for content changes and update detected variables
    useEffect(() => {
        const content = formData.content || '';
        const vars = extractVariables(content);
        setDetectedVariables(vars);
        // Add new variable keys to formData if missing
        if (vars.length > 0) {
            setFormData(prev => {
                const updated = { ...prev };
                vars.forEach((v) => {
                    if (updated[v] === undefined) updated[v] = '';
                });
                // Remove deleted variables
                Object.keys(updated).forEach((key) => {
                    if (!vars.includes(key) && key !== 'content' && !fields.some(f => f.key === key)) {
                        delete updated[key];
                    }
                });
                return updated;
            });
        }
    }, [formData.content, fields]);

    const handleChange = (key, value) => {
        setFormData(prev => ({ ...prev, [key]: value }));
    };

    const parseExistingFiles = (value) => {
        if (!value || value === 'null') {
            return [];
        }

        return String(value)
            .split(',')
            .map((item) => item.trim())
            .filter(Boolean);
    };

    const getRemovedKeyForCurrentFileKey = (currentFileKey) => {
        if (currentFileKey === 'filePath') {
            return 'removedProductDocuments';
        }
        if (currentFileKey === 'onboardingFilePath') {
            return 'removedOnboardingFiles';
        }
        return '';
    };

    const stripHtml = (value) => {
        if (!value) {
            return '';
        }

        return String(value)
            .replace(/<[^>]*>/g, ' ')
            .replace(/&nbsp;/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    };

    const isRequiredFieldEmpty = (field) => {
        if (!field?.required || field?.readOnly) {
            return false;
        }

        if (field.type === 'file') {
            const newFiles = Array.isArray(formData[field.key])
                ? formData[field.key].filter((fileObj) => fileObj && fileObj.name)
                : [];

            const existingFiles = field.currentFileKey
                ? parseExistingFiles(data?.[field.currentFileKey])
                : [];
            const removedKey = getRemovedKeyForCurrentFileKey(field.currentFileKey);
            const removedFiles = new Set(Array.isArray(formData[removedKey]) ? formData[removedKey] : []);
            const remainingExistingFiles = existingFiles.filter((fileName) => !removedFiles.has(fileName));

            return newFiles.length + remainingExistingFiles.length === 0;
        }

        if (field.type === 'multiselect') {
            return !(Array.isArray(formData[field.key]) && formData[field.key].length > 0);
        }

        if (field.type === 'quill') {
            return !stripHtml(formData[field.key]);
        }

        return !String(formData[field.key] || '').trim();
    };

    const isSaveDisabled = isSaving || (fields || []).some((field) => isRequiredFieldEmpty(field));

    const handleImproveField = async (fieldKey) => {
        if (!onImproveQuillField || !fieldKey) {
            return;
        }

        try {
            setImprovingFieldKey(fieldKey);
            const currentValue = formData[fieldKey] || '';
            const improved = await onImproveQuillField(fieldKey, currentValue);
            if (typeof improved === 'string' && improved.trim()) {
                handleChange(fieldKey, improved);
            }
        } finally {
            setImprovingFieldKey('');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsSaving(true);
            await onSave(formData);
        } finally {
            setIsSaving(false);
        }
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div 
            onClick={handleBackdropClick}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999] p-4 animate-fade-in"
        >
            <style>{`
                @keyframes fade-in {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                @keyframes slide-up {
                    from { 
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to { 
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                .animate-fade-in {
                    animation: fade-in 0.2s ease-out;
                }
                .animate-slide-up {
                    animation: slide-up 0.3s ease-out;
                }
                .edit-modal-description-editor .ql-container {
                    min-height: 220px;
                }
                .edit-modal-description-editor .ql-editor {
                    min-height: 180px;
                }
                .edit-modal-custom-toolbar {
                    border-radius: 6px 6px 0 0;
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between;
                    gap: 8px;
                    flex-wrap: wrap;
                }
                .edit-modal-custom-toolbar .edit-modal-toolbar-controls {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    flex: 1 1 540px;
                    min-width: 0;
                }
                .edit-modal-custom-toolbar .ql-formats {
                    margin-right: 10px;
                }
                .edit-modal-custom-toolbar .improve-ai-btn {
                    width: 140px !important;
                    height: auto !important;
                    display: inline-flex !important;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    white-space: normal !important;
                }
            `}</style>
            <div 
                className="bg-white rounded-xl w-full max-w-4xl max-h-[90vh] overflow-hidden shadow-2xl flex flex-col animate-slide-up"
            >
                {/* Header */}
                <div className="px-8 py-6 border-b border-gray-200 flex justify-between items-center">
                    <h3 className="text-xl font-semibold text-gray-900 m-0">{title}</h3>
                    <button
                        onClick={onClose}
                        className="w-8 h-8 rounded-md flex items-center justify-center p-0 border-0 bg-transparent hover:bg-gray-100 transition-all duration-200 hover:rotate-90"
                    >
                        <X size={20} className="text-gray-600" />
                    </button>
                </div>

                {/* Form Content */}
                <div className="flex-1 overflow-auto px-8 py-6">
                    {fields && fields.length > 0 ? (
                        fields.map((field) => (
                            <div key={field.key} className="mb-2">
                                <label className="block mb-2 text-sm font-medium text-gray-700">
                                    {field.label}
                                    {field.required ? (
                                        <span className="ml-1 text-red-600">*</span>
                                    ) : null}
                                </label>
                                {field.type === 'multiselect' ? (
                                    <>
                                        {/* Selected chips */}
                                        <div className="flex flex-wrap gap-2 mb-2">
                                            {(Array.isArray(formData[field.key]) ? formData[field.key] : []).map((selected, idx) => {
                                                const optionObj = field.options?.find(opt => (typeof opt === 'object' ? opt.value : opt) === selected);
                                                return (
                                                    <span key={selected} className="inline-flex items-center px-3 py-1 rounded-full bg-red-100 text-red-700 text-xs font-medium">
                                                        {optionObj ? (optionObj.label || optionObj.value) : selected}
                                                        <button
                                                            type="button"
                                                            className="ml-2 text-red-500 hover:text-red-700 focus:outline-none"
                                                            onClick={() => {
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    [field.key]: prev[field.key].filter((v) => v !== selected)
                                                                }));
                                                            }}
                                                            aria-label={`Remove ${selected}`}
                                                        >
                                                            ×
                                                        </button>
                                                    </span>
                                                );
                                            })}
                                        </div>
                                        {/* Dropdown for remaining options */}
                                        <select
                                            value=""
                                            onChange={e => {
                                                const value = e.target.value;
                                                if (!value) return;
                                                setFormData(prev => ({
                                                    ...prev,
                                                    [field.key]: Array.isArray(prev[field.key]) ? [...prev[field.key], value] : [value]
                                                }));
                                            }}
                                            disabled={field.readOnly}
                                            className="w-full px-3.5 py-2.5 rounded-lg border-2 border-gray-300 text-sm disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200 bg-white"
                                        >
                                            <option value="">Select options</option>
                                            {field.options?.filter(option => {
                                                const val = typeof option === 'object' ? option.value : option;
                                                return !(Array.isArray(formData[field.key]) && formData[field.key].includes(val));
                                            }).map(option => (
                                                <option key={typeof option === 'object' ? option.value : option} value={typeof option === 'object' ? option.value : option}>
                                                    {typeof option === 'object' ? option.label : option}
                                                </option>
                                            ))}
                                        </select>
                                    </>
                                ) : field.type === 'select' ? (
                                    <select
                                        value={formData[field.key] || ''}
                                        onChange={(e) => handleChange(field.key, e.target.value)}
                                        disabled={field.readOnly}
                                        className="w-full px-3.5 py-2.5 rounded-lg border-2 border-gray-300 text-sm disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200 bg-white"
                                    >
                                        <option value="">Select an option</option>
                                        {field.options?.map((option) => (
                                            <option 
                                                key={typeof option === 'object' ? option.value : option} 
                                                value={typeof option === 'object' ? option.value : option}
                                            >
                                                {typeof option === 'object' ? option.label : option}
                                            </option>
                                        ))}
                                    </select>
                                ) : field.type === 'textarea' ? (
                                    <textarea
                                        value={formData[field.key] || ''}
                                        onChange={(e) => handleChange(field.key, e.target.value)}
                                        disabled={field.readOnly}
                                        rows={field.rows || 3}
                                        className="w-full px-3.5 py-2.5 rounded-lg border-2 border-gray-300 text-sm  disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200 resize-y"
                                    />
                                ) : field.type === 'quill' ? (
                                    <>
                                        <div
                                            id={`edit-modal-toolbar-${field.key}`}
                                            className="ql-toolbar ql-snow edit-modal-custom-toolbar"
                                        >
                                            <div className="edit-modal-toolbar-controls">
                                                <span className="ql-formats">
                                                    <select className="ql-header" defaultValue="">
                                                        <option value="1">Heading 1</option>
                                                        <option value="2">Heading 2</option>
                                                        <option value="3">Heading 3</option>
                                                        <option value="">Normal</option>
                                                    </select>
                                                </span>
                                                <span className="ql-formats">
                                                    <button className="ql-bold" />
                                                    <button className="ql-italic" />
                                                    <button className="ql-underline" />
                                                    <button className="ql-strike" />
                                                </span>
                                                <span className="ql-formats">
                                                    <select className="ql-color" />
                                                    <select className="ql-background" />
                                                </span>
                                                <span className="ql-formats">
                                                    <button className="ql-list" value="ordered" />
                                                    <button className="ql-list" value="bullet" />
                                                </span>
                                                <span className="ql-formats">
                                                    <select className="ql-align" />
                                                </span>
                                                <span className="ql-formats">
                                                    <button className="ql-link" />
                                                    <button className="ql-image" />
                                                    <button className="ql-clean" />
                                                </span>
                                            </div>
                                            {typeof onImproveQuillField === 'function' ? (
                                                <button
                                                    type="button"
                                                    onClick={() => handleImproveField(field.key)}
                                                    disabled={field.readOnly || improvingFieldKey === field.key}
                                                    className="improve-ai-btn px-3 py-1.5 rounded-md border border-[#bb1ccc] bg-white text-xs font-semibold text-[#7d1fa3] disabled:opacity-60 disabled:cursor-not-allowed"
                                                >
                                                    {improvingFieldKey === field.key ? 'Improving...' : 'Improve with AI'}
                                                </button>
                                            ) : null}
                                        </div>
                                        <ReactQuill
                                            className="edit-modal-description-editor"
                                            value={formData[field.key] || ''}
                                            onChange={(value) => handleChange(field.key, value)}
                                            readOnly={field.readOnly}
                                            modules={getQuillModules(`edit-modal-toolbar-${field.key}`)}
                                            formats={quillFormats}
                                            placeholder={field.placeholder || 'Enter description'}
                                        />
                                    </>
                                ) : field.type === 'file' ? (
                                    <>
                                        <input
                                            id={`edit-file-input-${field.key}`}
                                            type="file"
                                            multiple={Boolean(field.multiple)}
                                            onChange={(e) => {
                                                const selectedFiles = Array.from(e.target.files || []);
                                                handleChange(field.key, selectedFiles);
                                            }}
                                            disabled={field.readOnly}
                                            accept=".pdf,.doc,.docx,.txt,.xls,.xlsx,.ppt,.pptx"
                                            className="hidden"
                                        />
                                        <label
                                            htmlFor={`edit-file-input-${field.key}`}
                                            className="block"
                                            style={{
                                                display: 'block',
                                                width: '100%',
                                                padding: '12px 10px',
                                                borderRadius: 4,
                                                border: '1px solid #ccc',
                                                fontSize: 16,
                                                height: 48,
                                                boxSizing: 'border-box',
                                                lineHeight: '24px',
                                                cursor: field.readOnly ? 'not-allowed' : 'pointer',
                                                backgroundColor: field.readOnly ? '#f5f5f5' : '#fff',
                                                color: Array.isArray(formData[field.key]) && formData[field.key].length ? '#333' : '#999',
                                            }}
                                        >
                                            {Array.isArray(formData[field.key]) && formData[field.key].length
                                                ? `${formData[field.key].length} file(s) selected`
                                                : 'Choose files...'}
                                        </label>

                                        {Array.isArray(formData[field.key]) && formData[field.key].length > 0 ? (
                                            <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                                                {formData[field.key].map((selectedFile, index) => (
                                                    <div
                                                        key={`${selectedFile?.name || 'file'}-${index}`}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 8,
                                                            padding: '8px 12px',
                                                            backgroundColor: '#f0f0f0',
                                                            borderRadius: 4,
                                                        }}
                                                    >
                                                        <span style={{ fontWeight: 500 }}>{selectedFile?.name || `File ${index + 1}`}</span>
                                                        <span style={{ color: '#666', fontSize: 12 }}>
                                                            ({selectedFile?.size ? (selectedFile.size / 1024).toFixed(2) : '0.00'} KB)
                                                        </span>
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                const nextFiles = Array.from(formData[field.key] || []).filter((_, i) => i !== index);
                                                                handleChange(field.key, nextFiles);
                                                            }}
                                                            disabled={field.readOnly}
                                                            style={{
                                                                background: 'none',
                                                                border: 'none',
                                                                cursor: field.readOnly ? 'not-allowed' : 'pointer',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                opacity: field.readOnly ? 0.5 : 1,
                                                            }}
                                                        >
                                                            <Trash2 color="#ef4444" size={16} />
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : null}

                                        {field.currentFileKey ? (
                                            <div className="mt-2 rounded-md border border-gray-200 bg-gray-50 px-3 py-2">
                                                <p className="text-xs font-semibold text-gray-700 mb-1">Current files</p>
                                                {(() => {
                                                    const removedKey = getRemovedKeyForCurrentFileKey(field.currentFileKey);
                                                    const removedFiles = new Set(Array.isArray(formData[removedKey]) ? formData[removedKey] : []);
                                                    const visibleExistingFiles = parseExistingFiles(data?.[field.currentFileKey]).filter(
                                                        (existingFile) => !removedFiles.has(existingFile)
                                                    );

                                                    return visibleExistingFiles.length > 0 ? (
                                                    <div className="flex flex-wrap gap-2">
                                                        {visibleExistingFiles.map((existingFile, index) => (
                                                            <span
                                                                key={`${existingFile}-${index}`}
                                                                className="inline-flex items-center gap-2 px-3 py-1 rounded bg-gray-200 text-xs text-gray-700"
                                                                title={existingFile}
                                                            >
                                                                {existingFile}
                                                                <button
                                                                    type="button"
                                                                    onClick={() => {
                                                                        if (!removedKey) {
                                                                            return;
                                                                        }

                                                                        setFormData((prev) => {
                                                                            const existingRemoved = Array.isArray(prev[removedKey]) ? prev[removedKey] : [];
                                                                            if (existingRemoved.includes(existingFile)) {
                                                                                return prev;
                                                                            }
                                                                            return {
                                                                                ...prev,
                                                                                [removedKey]: [...existingRemoved, existingFile],
                                                                            };
                                                                        });
                                                                    }}
                                                                    disabled={field.readOnly}
                                                                    style={{
                                                                        background: 'none',
                                                                        border: 'none',
                                                                        cursor: field.readOnly ? 'not-allowed' : 'pointer',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        opacity: field.readOnly ? 0.5 : 1,
                                                                        padding: 0,
                                                                    }}
                                                                    aria-label={`Delete ${existingFile}`}
                                                                >
                                                                    <Trash2 color="#ef4444" size={14} />
                                                                </button>
                                                            </span>
                                                        ))}
                                                    </div>
                                                    ) : (
                                                    <p className="text-xs text-gray-500">No files uploaded</p>
                                                    );
                                                })()}
                                            </div>
                                        ) : null}
                                    </>
                                ) : (
                                    <input
                                        type={field.type || "text"}
                                        value={formData[field.key] || ''}
                                        onChange={(e) => handleChange(field.key, e.target.value)}
                                        disabled={field.readOnly}
                                        className={
                                            field.type === 'date' || field.key === 'name'
                                                ? "w-full px-3.5 py-2.5 rounded-lg border-2 border-gray-300 text-sm disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200"
                                                : "w-full px-3.5 py-2.5 rounded-lg border-2 border-gray-300 text-sm disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200"
                                        }
                                    />
                                )}
                            </div>
                        ))
                    ) : (
                        <div className="text-center py-5 text-gray-500">
                            No fields to display
                        </div>
                    )}

                    {/* Detected Variables Section */}
                    {detectedVariables && detectedVariables.length > 0 && (
                        <div className="mt-6">
                            <label className="block mb-2 text-base font-semibold text-gray-800">Detected Variables:</label>
                            <div className="flex flex-wrap gap-4">
                                {detectedVariables.map((varName) => (
                                    <div key={varName} className="flex-1 min-w-[180px]">
                                        <label className="block text-sm font-medium text-gray-700 mb-1">{varName}</label>
                                        <input
                                            type="text"
                                            value={formData[varName] || ''}
                                            onChange={(e) => handleChange(varName, e.target.value)}
                                            placeholder={`Enter value for ${varName}`}
                                            className="w-full px-3.5 py-2.5 rounded-lg border-2 border-gray-300 text-sm  disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200"
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                {/* Footer */}
                {isSaving && typeof saveProgress === 'number' ? (
                    <div className="px-8 pt-3">
                        <div className="flex items-center justify-between text-xs text-gray-700 mb-1">
                            <span>{saveStatusText || 'Uploading files...'}</span>
                            <span>{saveProgress}%</span>
                        </div>
                        <div className="h-2 w-full rounded-full bg-gray-200 overflow-hidden">
                            <div
                                className="h-full bg-red-600 transition-all duration-200"
                                style={{ width: `${saveProgress}%` }}
                            />
                        </div>
                    </div>
                ) : null}

                {errorMessage ? (
                    <div className="px-8 pt-3">
                        <p className="text-sm text-red-600">{errorMessage}</p>
                    </div>
                ) : null}

                <div className="px-8 py-3 border-t border-gray-200 bg-gray-50 flex justify-end gap-3">
                    <button 
                        type="button"
                        onClick={onClose} 
                        disabled={isSaving}
                        className="px-6 py-2.5 rounded-lg border-2 border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 hover:-translate-y-0.5 hover:shadow-lg disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none transition-all duration-200 active:translate-y-0"
                    >
                        Cancel
                    </button>
                    <button 
                        type="button"
                        onClick={handleSubmit}
                        disabled={isSaveDisabled}
                        className="px-7 py-2.5 rounded-lg border-0 bg-gradient-to-br from-red-600 to-red-700 text-sm font-medium text-white hover:from-red-700 hover:to-red-800 hover:-translate-y-0.5 hover:shadow-lg disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none transition-all duration-200 active:translate-y-0"
                    >
                        {isSaving
                            ? (typeof saveProgress === 'number' ? `Saving... ${saveProgress}%` : 'Saving...')
                            : 'Save Changes'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default EditModal;